import { useEffect } from "react";
import { itemsService } from "../../services/items.service";
import {
  SetTItemList,
  GetItemList,
  SettItemBackupList,
  GetItemBackupList,
} from "../../store/itemAtom";
import { useParams } from "react-router-dom";
import { twMerge } from "tailwind-merge";

function ItemDetailsSideScroll(props) {
  const setItemListState = SetTItemList();
  const setItemBackupList = SettItemBackupList();
  const itemListData = GetItemList();
  const itemMasterList = GetItemBackupList();
  const { item_id } = useParams();

  useEffect(() => {
    if (itemListData.item_info.length < 1) {
      itemsService.getItemsList().then((res) => {
        if (res?.data !== undefined) {
          setItemListState(res?.data);
          setItemBackupList(res?.data);
        }
      });
    }
  }, [itemListData?.item_info.length]);

  function customFilter(e) {
    const value = Number(e.target.value);
    if (value === 0) return setItemListState(itemMasterList);
    
    const filters = {
      1: (item) => item.Item_Variety_Id === 2,
      2: (item) => item.Item_Variety_Id === 1,
      3: (item) => item.Item_Category_Id === 1,
      4: (item) => item.Item_Category_Id === 2,
    };

    if (filters[value]) {
      const filtered = itemMasterList.filter(filters[value]);
      setItemListState(filtered);
    }
  }

  return (
    <div
     className="w-full h-screen p-2 border-[1px] border-gray-200 rounded-lg overflow-y-auto scrollbar-thumb-gray-400 scrollbar-thin scrollbar-track-gray-200"
      onChange={customFilter}
    >
      {itemListData?.item_info.map((item, i) => (
        <div
          className={twMerge(
            "border px-2 py-3 cursor-pointer border-gray-200 transition-colors",
            Number(item_id) === item.Item_Id ? "bg-gray-200" : "hover:bg-gray-100"
          )}
          key={item.Item_Id || i}
          onClick={() => props.viewItemDetails(item.Item_Id)}
        >
          <span className="text-xs font-medium text-gray-600">
            {item.Item_Name}
          </span>{" "}
          |{" "}
          <span className="text-xs font-medium text-gray-700">
            {item?.Item_Type_Name}
          </span>
          <br />
          <div className="text-sm font-medium text-primary">
            {item?.Item_Variety_Name}
          </div>
        </div>
      ))}
    </div>
  );
}

export default ItemDetailsSideScroll;